import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"ic_cert\" clip-path=\"url(#clip0_1_14349)\"><g id=\"Group 3902\"><g id=\"Group 3901\"><rect id=\"Rectangle 2812\" x=\"6.41699\" y=\"5.44482\" width=\"6.74004\" height=\"6.62378\" fill=\"#D7D8DB\"></rect><rect id=\"Rectangle 2813\" x=\"13.5781\" y=\"5.44482\" width=\"6.74004\" height=\"6.62378\" fill=\"#D7D8DB\"></rect></g><g id=\"Group 4048\"><path id=\"Vector 440\" d=\"M2 19.8856V8.90369C2 7.38006 3.14227 6.10122 4.64128 5.82843C6.01918 5.57768 7.68651 5.20882 9 4.7179C10.661 4.09707 12.8879 2.85805 14.3798 1.98129C15.3781 1.39456 16.6219 1.39456 17.6202 1.98129C19.1121 2.85805 21.339 4.09707 23 4.7179C24.3135 5.20882 25.9808 5.57768 27.3587 5.82843C28.8577 6.10122 30 7.37932 30 8.90294V19.8649C30 22.6542 25.2293 31.0206 16 31.0186C6.77735 31.0165 2 22.6698 2 19.8856Z\" fill=\"white\" stroke=\"#4D4E58\" stroke-width=\"2\"></path><path id=\"Vector 441\" d=\"M5.39453 19.3337V9.09388C5.39453 9.09388 8.6266 8.72415 10.6976 7.95786C12.7685 7.19156 16.0006 5.16943 16.0006 5.16943L16.0006 27.6834C9.01374 27.6818 5.39453 21.4218 5.39453 19.3337Z\" fill=\"#E0E5FF\"></path><g id=\"Group 4047\"><ellipse id=\"Ellipse 385\" cx=\"16.1699\" cy=\"16.2027\" rx=\"5.93939\" ry=\"5.83695\" fill=\"white\" stroke=\"#4D4E58\" stroke-width=\"2\"></ellipse><path id=\"Vector 6\" d=\"M13.2627 15.7343L15.2682 17.9117L18.6621 14.1973\" stroke=\"#4D4E58\" stroke-width=\"2\"></path></g></g></g></g><defs><clipPath id=\"clip0_1_14349\"><rect width=\"32\" height=\"32\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  name: 'Shield',
  props: {
    size: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size || 32,
    height: __props.size || 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})